<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <section class="title-section fixed-view">
      <e6-title>
        车辆离线报表
        <template slot="operate">
          <el-button
            class="g-form-section-search operate__item"
            title="表格列设置"
            icon="e6-icon-field_line"
            @click="columSetVisible = !columSetVisible"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            title="导出"
            v-if="operationSuper.导出"
            icon="e6-icon-export_line"
            @click="handleExportClick"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="searchData"
        @resetForm="handleResetForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="forms.alarmNameType">
            <e6Select
              :dataList="vehicleList"
              :filterable="true"
              slotTemplate="tree"
              :issingleleaf="true"
              :disabledNoCheck="false"
              multiple
              ref="vehicleTreeSelect"
              :placeholder="'车辆'"
              @multipleSelect="selVehicle"
            ></e6Select>
          </el-form-item>
          <el-form-item prop="forms.companyName">
            <el-input
              v-model="slotForms.forms.companyName"
              placeholder="所属企业"
            ></el-input>
          </el-form-item>
          <el-form-item prop="forms.outNum" label="离线时长">
            <el-input
              prefix-icon="el-icon-arrow-right"
              v-model.number="slotForms.forms.outNum"
              placeholder="请输入"
            ></el-input>
            <span class="tips">天</span>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->
    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        v-if="showTable"
        v-loading="tableLoading"
        ref="multipleTable"
        border
        :data="tableData"
        height="100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          label="序号"
          width="80"
          fixed
          type="index"
        ></el-table-column>
        <el-table-column
          v-for="(item, index) in localShowTableCols"
          :key="index"
          :show-overflow-tooltip="true"
          min-width="170"
          align="center"
          :prop="item.name"
          :label="item.title"
        ></el-table-column>
      </el-table>
      <div class="tips-wrapper" v-else>
        <div class="no-search" v-if="!noData">
          <p>您还没有查询车辆离线数据哦！</p>
          <el-button type="primary" @click="searchData">点击查询</el-button>
        </div>
        <div class="no-search" v-if="noData == true">
          <img src="@/assets/images/good.png" alt="" />
          <p>
            当前没有离线超过{{
              formExtend.forms.outNum == "" ? 3 : formExtend.forms.outNum
            }}天的车辆哦！
          </p>
        </div>
      </div>
    </section>
    <!-- 表格 end -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
    <!-- 表格列设置 -->
    <e6-column-set
      @setColumnSubmit="handleSetColumnSubmit"
      @setColumnCancel="handleSetColumnCancel"
      :columSetVisible.sync="columSetVisible"
      :hideTableCols.sync="copyHideTableCols"
      :showTableCols.sync="copyShowTableCols"
    ></e6-column-set>
    <!-- 表格列设置 end -->
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import { FetchVehicleOutline } from "@/api/report/vehicle";
import { FetchVehicleTree } from "@/api/base/vehicle";
import { mapActions } from "vuex";
import operationManage from "_private/mixins/operationManage";
import listInit from "@/mixins/listInit";
import { mergeFormExtend } from "_private/utils/merge";

export default {
  mixins: [operationManage, listInit],
  data() {
    return {
      dataType: "object",
      isSearch: false,
      noData: false, // 无离线数据
      vehicleList: [], // 车辆下拉数据源

      formExtend: {
        forms: {
          vehicleIdList: [],
          companyName: "",
          outNum: "",
        },
        extends: [],
      },
      // 表格列相关
      columSetVisible: false,
      multipleSelection: [],
      //导出URL
      exportUrl: "/base/vehicle/out/export?",
    };
  },
  created() {
    // 获取车辆下拉
    this.getVehicleList();
    this.setSearchFormIsOpenAct();
    // this.initPage();
  },
  methods: {
    ...mapActions(["setSearchFormIsOpenAct"]),

    // 获取车辆下拉
    async getVehicleList() {
      try {
        let res = await FetchVehicleTree();
        if (res.result && Array.isArray(res.result)) {
          this.vehicleList = res.result;
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 车辆选择的回调
    selVehicle(val) {
      this.formExtend.forms.vehicleIdList = [];
      if (val.length) {
        this.formExtend.forms.vehicleIdList = val.map((v) => {
          return v.id;
        });
      }
    },
    // 查询数据
    async searchData() {
      if (
        this.formExtend.forms.outNum != "" &&
        isNaN(this.formExtend.forms.outNum)
      ) {
        this.$message.warning("请输入≥4的自然数");
        return;
      }
      if (
        this.formExtend.forms.outNum != "" &&
        this.formExtend.forms.outNum < 4
      ) {
        this.$message.warning("请输入≥4的自然数");
        return;
      }
      this.curPage = 1;
      await this.initPage();
      if (this.tableData.length) {
        this.showTable = true;
        this.noData = false;
      } else {
        this.showTable = false;
        this.noData = true;
      }
    },
    // 请求列表数据
    getTableData() {
      try {
        let params = cloneDeep(this.mergeObj());
        return new Promise((resolve, reject) => {
          FetchVehicleOutline(params)
            .then((response) => {
              resolve(response);
            })
            .catch((error) => {
              reject(error);
            });
        });
      } catch (error) {
        console.log(error);
      }
    },
    // 整合查询数据
    mergeObj() {
      return Object.assign({}, mergeFormExtend(this.formExtend), {
        curPage: this.curPage,
        pageSize: this.pageSize,
      });
    },
    // 重置
    handleResetForm() {
      this.$refs.vehicleTreeSelect.multipleRemoveAll();
      this.formExtend.forms.vehicleIdList = [];
    },
    //导出
    handleExportClick() {
      if (
        this.formExtend.forms.outNum != "" &&
        isNaN(this.formExtend.forms.outNum)
      ) {
        this.$message.warning("请输入≥4的自然数");
        return;
      }
      if (
        this.formExtend.forms.outNum != "" &&
        this.formExtend.forms.outNum < 4
      ) {
        this.$message.warning("请输入≥4的自然数");
        return;
      }
      let param = "";
      param += "&companyName=" + this.formExtend.forms.companyName;
      param += "&outNum=" + this.formExtend.forms.outNum;
      param += "&vehicleIdList=" + this.formExtend.forms.vehicleIdList;
      document.location.href = this.exportUrl + param;
    },
  },
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 0 10px;
}

.table-section {
  height: 200px;
}

.pagination-section {
  padding: 10px 0;
}

.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}

.links {
  color: #0000ff;
  cursor: pointer;
}

/deep/ .el-button--primary {
  .e6-icon-export_line,
  .e6-icon-set-up_line {
    color: #fff !important;
  }
}
/deep/ .el-table__body-wrapper {
  height: calc(100% - 36px) !important;
}
/deep/ .el-table__fixed-body-wrapper {
  height: calc(100% - 36px) !important;
  top: 36px !important;
}
.tips-wrapper {
  height: 100%;
  background: #fff;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  .no-search {
    p {
      color: #999;
      font-size: 18px;
    }
  }
}
.tips {
  position: absolute;
  top: 0;
  right: 10px;
  color: #c0c4cc;
}
</style>
